import { Component } from '@angular/core';
import { TableInfopopupLayoutComponent } from '../core/tableinfopopup.layout.component';

@Component({
    selector: 'app-tableinfopopuplayoutmobile',
    templateUrl: '../desktop/tableinfopopup.layout.desktop.component.html',
    styleUrls: ['../css/tableinfopopup.layout.mobile.component.scss'],
    standalone: false
})
export class TableinfopopupLayoutMobileComponent extends TableInfopopupLayoutComponent {
  constructor() {
    super();
  }

  tableheadArr: any[] = [
    {
      name: '$100 - $1,000',
    },
    {
      name: '8 DECKS',
    },
    {
      name: 'SHUFFLE 100%',
    },
    {
      name: 'SPLIT 5-9',
    },
    {
      name: 'SOFT 17',
    },
  ];
}
